import { render } from "./EditMixModal.vue?vue&type=template&id=1b21a15e&ts=true"
import script from "./EditMixModal.vue?vue&type=script&lang=ts"
export * from "./EditMixModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__